var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPolygons2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 156,
    viewBox: "0 0 180 156",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.239 60.6953L157.405 37.3943L162.001 76.0351L126.239 60.6953Z",
    fill: "#4347A2",
    stroke: "#4347A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8753 9.05654L61.6577 13.9249L46.5504 30.3548L39.8753 9.05654Z",
    stroke: "#4347A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31672 129.771L30.0991 134.64L14.9918 151.07L8.31672 129.771Z",
    stroke: "#4347A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.074 128.641L73.5964 104.466L97.771 110.944L80.074 128.641Z",
    fill: "#4347A2",
    stroke: "#4347A2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPolygons2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/polygons2.58de55b1.svg";
export { ForwardRef as ReactComponent };